var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3561 35.25H30.6442C32.6325 35.25 33.6312 34.2436 33.6312 32.289V22.3763C33.6312 20.4178 32.6325 19.4153 30.6442 19.4153H27.8789V20.8134H30.6191C31.6414 20.8134 32.2379 21.3722 32.2379 22.4446V32.2207C32.2379 33.3017 31.6414 33.848 30.6191 33.848H19.3812C18.3348 33.848 17.7625 33.3017 17.7625 32.2207V22.4446C17.7625 21.3722 18.3348 20.8134 19.3812 20.8134H22.1292V19.4153H19.3561C17.3765 19.4153 16.3691 20.4101 16.3691 22.3763V32.289C16.3691 34.2513 17.3765 35.25 19.3561 35.25ZM24.9958 27.625C25.3721 27.625 25.6925 27.3132 25.6925 26.9456V16.6152L25.6367 15.1613L26.4042 15.9673L27.9853 17.6263C28.1133 17.7629 28.2923 17.8351 28.4588 17.8351C28.8186 17.8351 29.0958 17.5753 29.0958 17.2289C29.0958 17.0364 29.0188 16.9037 28.8822 16.7757L25.4962 13.4809C25.3249 13.3097 25.1796 13.25 24.9958 13.25C24.8207 13.25 24.6715 13.3097 24.4955 13.4809L21.1056 16.7757C20.9776 16.9037 20.9006 17.0364 20.9006 17.2289C20.9006 17.5753 21.1653 17.8351 21.529 17.8351C21.6955 17.8351 21.8831 17.7629 22.0072 17.6263L23.5922 15.9673L24.3636 15.1575L24.3078 16.6152V26.9456C24.3078 27.3132 24.6283 27.625 24.9958 27.625Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.90126e735ad5f65ed89b5dd9c94c5e3d.svg";
export { ForwardRef as ReactComponent };